module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_about02-33c9244805fd55879cfc101a7024bd41.png";